import { useCallback } from "react"

import { cortexGet } from "./cortexFetch"
import { parseAnswerSources } from "./cortexQuestions"

// Fetches prior questions/answers for a knowledge base + external id (a
// ticket's uniqueid for the sidebar, the persistent tab id for the fullTab
// surface) and shapes them into the same message-list format used while
// chatting live.
const useConversationHistory = ({ assistantUrl, accessToken }) => {
    const fetchHistory = useCallback(async (kbId, externalId) => {
        if (!assistantUrl || !accessToken || !externalId || !kbId)
            return []

        const res = await cortexGet(`${assistantUrl}/ai/questions/?externalId=${kbId}${externalId}&limit=100`, accessToken)
        if (res.status !== 200) return []

        const data = await res.json()
        const questions = data.Questions || []

        const messages = []
        for (let i = questions.length - 1; i >= 0; i--) {
            const question = questions[i]
            messages.push({ id: 0, text: question.question, userId: 1 })

            // aio-api persists two one-way flags on the Question: `innapropriate`
            // (set only by the bad-answer button) and `used_answer` (set by
            // send-now, copy-to-edit, *and* mark-good alike, so it can't tell
            // those three apart). Rejected is unambiguous; anything used-but-not-
            // rejected is shown as accepted, which matches the common case
            // (rating a question and reloading) even though a plain send/copy
            // without ever rating will also show as "already marked good".
            // Carry question + sources on the restored answer message too, so
            // acting on a historical answer (send/copy/rate after a reload)
            // still reports a complete curadoria event - see reportAction in
            // useCortexChat.js.
            const answerMessage = {
                id: question.id,
                text: question.answer,
                userId: 0,
                question: question.question,
                sources: parseAnswerSources(question.answer_sources),
            }
            if (question.innapropriate) {
                answerMessage.messageInteracted = true
                answerMessage.messageRejected = true
            } else if (question.used_answer) {
                answerMessage.messageInteracted = true
                answerMessage.messageAccepted = true
            }
            messages.push(answerMessage)
        }
        return messages
    }, [assistantUrl, accessToken])

    return { fetchHistory }
}

export default useConversationHistory
